import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
import Router from 'vue-router'
import './assets/scss/index.scss'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {
  http
} from './request/api'
import {domain} from './config.js'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.use(VueQuillEditor)
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.getCurrentUserId = function() {
  try {
    return store.state.user.id;
  } catch (e) {
    return 0;
  }
}
Vue.prototype.showLoading = function()
{
  this.$loading({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
}
Vue.prototype.closeLoading = function(){
  this.$loading().close();
}

Vue.prototype.domain = domain

Vue.use(ElementUI);
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js